import React from 'react';
export function Footer() {
  return <footer className="bg-ink text-white py-12 border-t border-white/10" data-id="element-55">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-56">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-57">
          <div className="text-center md:text-left" data-id="element-58">
            <a href="#" className="inline-block mb-2" data-id="element-59">
              <img src="https://cdn.magicpatterns.com/uploads/eMfWtjHpDD7x9U2JTU6YmP/TheSprintStudio_Logo_(2).png" alt="The Sprint Studio" className="h-8 w-auto brightness-0 invert" data-id="element-60" />
            </a>
            <p className="text-slate-400 text-sm mt-2" data-id="element-61">
              Sprint-sized creative & product work.
            </p>
          </div>

          <nav className="flex flex-wrap justify-center gap-8" data-id="element-62">
            <a href="#services" className="text-sm text-slate-300 hover:text-white transition-colors" data-id="element-63">
              Services
            </a>
            <a href="#retainers" className="text-sm text-slate-300 hover:text-white transition-colors" data-id="element-64">
              Retainers
            </a>
            <a href="#team" className="text-sm text-slate-300 hover:text-white transition-colors" data-id="element-65">
              Team
            </a>
            <a href="#contact" className="text-sm text-slate-300 hover:text-white transition-colors" data-id="element-66">
              Contact
            </a>
          </nav>

          <div className="text-center md:text-right" data-id="element-67">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-white/10 text-xs font-medium text-accentLight border border-white/10" data-id="element-68">
              Woman Owned
            </span>
            <p className="text-slate-500 text-xs mt-3" data-id="element-69">
              © {new Date().getFullYear()} The Sprint Studio.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}